import React, { Component } from 'react'
import mediaFiles from '../../../../../apis/wpApi/mediaFiles'
import ImageUploadComponent from './ImageUploadComponent'


class ImageUpload extends Component  {
    constructor(props) {
        super(props)

        this.state = {
            filesAccepted: [],
            filesRejected: []
        }

        this.accept = "image/jpeg, image/png, image/webp"

        this.transIds = {
            textAccept : [
                "images_uploads_textAccept_sing",
                "images_uploads_textAccept_plur"
            ],
            textRejectedList: [
                "images_uploads_textRejectedList_sing",
                "images_uploads_textRejectedList_plur"
            ],
            textInDropzone: [
                "images_uploads_textInDropzone_sing",
                "images_uploads_textInDropzone_plur"
            ],
            textButtonOpenFileDialog: [
                "images_uploads_textButtonOpenFileDialog_sing",
                "images_uploads_textButtonOpenFileDialog_plur"
            ],
            textButtonDeleteFiles: [
                "images_uploads_textButtonDeleteFiles_sing",
                "images_uploads_textButtonDeleteFiles_plur",
            ],
            textButtonUploadFiles: [
                "images_uploads_textButtonUploadFiles_sing",
                "images_uploads_textButtonUploadFiles_plur"
            ]
        }

        this.refDropzone = React.createRef()

        this.onDrop = this.onDrop.bind(this)
        this.onCancel = this.onCancel.bind(this)
        this.onUploadStart = this.onUploadStart.bind(this)
        this.onUploadEndSuccess = this.onUploadEndSuccess.bind(this)
        this.onUploadEndError = this.onUploadEndError.bind(this)
        this.addPreviewURLtoFiles = this.addPreviewURLtoFiles.bind(this)
    }

    componentWillUnmount() {
        const { filesAccepted } = this.state

        filesAccepted.map(file => {
            URL.revokeObjectURL(file.preview)
        })
    }

    addPreviewURLtoFiles(files) {
        return files.map(file => {
            file.preview = URL.createObjectURL(file)
            return file
        })
    }

    onDrop(accepted, rejected) {
        this.setState({
            filesAccepted: this.addPreviewURLtoFiles(accepted),
            filesRejected: rejected
        })
    }

    onCancel() {
        this.setState({
            filesAccepted: [],
            filesRejected: []
        })
    }

    onUploadStart() {
        const { filesAccepted } = this.state
        const { onUploadStart } = this.props

        onUploadStart()

        filesAccepted.forEach(file => {
            mediaFiles.create(
                file, 
                file.name,
                this.onUploadEndSuccess, 
                this.onUploadEndError
            )
        })
    }

    onUploadEndSuccess(data) {
        const { onUploadEndSuccess } = this.props

        this.onCancel()
        onUploadEndSuccess(data)
    }

    onUploadEndError(error) {
        const { onUploadEndError } = this.props

        onUploadEndError(error)
    }

    render() {
        const { filesAccepted, filesRejected, isDisabled } = this.state

        return <ImageUploadComponent 
            filesAccepted={filesAccepted}
            filesRejected={filesRejected}
            isDisabled={isDisabled}
            transIds={this.transIds}
            accept={this.accept}
            refDropzone={this.refDropzone}
            onDrop={this.onDrop}
            onCancel={this.onCancel}
            onUpload={this.onUploadStart}
        />
    }
}


export default ImageUpload